module.exports = __webpack_public_path__ + "food_line.svg?e1a14706a7b9877c4f75f3c8553f4194";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/food_line.svg
// module id = 34
// module chunks = 0